import { useEffect, useState } from 'react';

const ENABLED = false;
const DISABLED = true;

export function useDisabledState({
  orderStatus,
  paymentMethodReady,
  requiresPaymentMethod,
}) {
  let initialState = DISABLED;

  const [disabled, setState] = useState(initialState);

  // Monitors state changes that can affect form disabled state.
  useEffect(() => {
    const shouldDisable =
      orderStatus != 'started' ||
      (requiresPaymentMethod && !paymentMethodReady);
    const shouldEnable =
      !requiresPaymentMethod || (requiresPaymentMethod && paymentMethodReady);

    if (shouldDisable) setState(DISABLED);
    if (shouldEnable) setState(ENABLED);
  }, [orderStatus, paymentMethodReady, requiresPaymentMethod]);

  return { disabled };
}
